export default __webpack_public_path__ + "static/triebwerk-ac247a143b5e3ac799439a0204cf2713.webp";